<template>
  <div
    class="digit-scroll-counter"
    :style="`--max-scroll: ${maxScrollPercent}%`"
  >
    <div class="digit-scroll-counter__number">
      <strong>
        <span
          v-for="(digit, index) in digits"
          :key="index"
          class="digit-scroll-counter__number-digit"
        >
          <i v-for="n in Number(maxScrollNumber)" :key="n">{{ n }}</i>
          {{ digit }}
        </span>
      </strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DigitScrollCounter',
  props: {
    number: {
      type: Number,
      required: true,
    },
  },
  computed: {
    digits() {
      if (typeof this.number === 'number' && this.number > 0) {
        const digits = Math.floor(this.number)
        return digits.toString().split('')
      }
      return ['00']
    },
    maxScrollNumber() {
      return Math.max(...this.digits.map(digit => Number(digit)))
    },
    maxScrollPercent() {
      return this.maxScrollNumber * 100
    },
  },
}
</script>

<style lang="scss" scoped>
$full-height: var(--max-scroll);
.digit-scroll-counter {
  color: var(--white);
  position: relative;
  *zoom: 1;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
  }

  &:after {
    clear: both;
  }

  &:before,
  &:after {
    content: ' ';
    display: table;
  }

  strong {
    display: inline-block;
  }

  span {
    display: inline-block;
  }

  &__number {
    float: right;
    position: relative;
    overflow: hidden;

    &-digit {
      position: relative;
      transform: translate3d(0, $full-height, 0);
      animation: countdown 1s forwards;
      @for $i from 1 to 4 {
        &:nth-of-type(#{$i}) {
          animation-delay: $i * 0.1 + s;
        }
      }

      i {
        font-style: normal;
        position: absolute;
        @for $i from 1 to 10 {
          &:nth-child(#{$i}) {
            top: $i * -100%;
          }
        }
      }
    }
  }
}

@keyframes countdown {
  from {
    transform: translateY($full-height);
  }

  to {
    transform: translateY(0);
  }
}
</style>
